import clsx, { type ClassValue } from 'clsx';

/** Class-name joiner used by every component. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
